import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";
import StoreDB from "./store";
import { MenuEntity } from "../entities/stores/menuIfood";

class MenuIfoodDB extends FirestorePipe {
    public static readonly colName = "MenuDelivery";

    constructor(idEstab: string, idStore: string, entity: MenuEntity) {
        if (!idEstab)
            throw new Error('Informe o id do estabelecimento')
        if (!idStore)
            throw new Error('Informe o id do store')
        if (!entity)
            throw new Error('Informe a entidade')
        super(`${EstablishmentDB.colName}/${idEstab}/${StoreDB.colName}/${idStore}/${MenuIfoodDB.colName}/ifood/${entity}`);
    }



    public async create(data: any): Promise<any> {
        throw new Error('Method not exists')
    }
    public async define(id: string, data: any): Promise<any> {
        return this._define(id, data);
    }
    public async update(id: string, data: any): Promise<any> {
        return this._update(id, data);
    }
    public delete(id: string): Promise<any> {
        throw new Error('Method not exists')
    }
    public getAll(...params: QueryConstraint[]): Promise<any[]> {
        return this._getAll<any>(...params);
    }
    public get(id: string): Promise<any> {
        return this._get(id);
    }
    public on<T>(listener: (data: T[]) => void, ...params: QueryConstraint[]): Unsubscribe {
        return this._on(listener, ...params);
    }

}

export default MenuIfoodDB;
